import React, { useState } from 'react';
import { ColorPicker, HueSpectrum, SaturationSpectrum } from '@vtaits/react-color-picker';
import '@vtaits/react-color-picker/index.css';

// A new reusable component that uses the ColorPicker for theme customization
const PrayselyColorPicker = ({ initialColor = 'blue', onThemeApply, onSelectClick }) => {
  const [selectedColor, setSelectedColor] = useState(initialColor);
  const [customHex, setCustomHex] = useState(initialColor); 

    const handleColorChange = (color) => {
    setSelectedColor(color);
    setCustomHex(color);
    // Simulate applying the theme (e.g., save to localStorage or props)
    if (onThemeApply) {
      onThemeApply(color);
    }
  };

  const handleHexChange = (e) => {
    const val = e.target.value;
    setCustomHex(val);
    // Normalize and validate (6-digit hex)
    let hex = val.startsWith('#') ? val : '#' + val;
    if (hex.length === 7 && /^#[0-9A-Fa-f]{6}$/i.test(hex)) {
      setSelectedColor(hex);
      if (onThemeApply) {
        onThemeApply(hex);
      }
    }
  };

  const handleHexKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Re-validate and apply if needed
      let hex = customHex.startsWith('#') ? customHex : '#' + customHex;
      if (hex.length === 7 && /^#[0-9A-Fa-f]{6}$/i.test(hex)) {
        setSelectedColor(hex);
        if (onThemeApply) {
          onThemeApply(hex);
        }
      } else {
        // Reset to current if invalid
        setCustomHex(selectedColor);
      }
    }
  };


  const handleSelectCallback = () => {
    onSelectClick()
  }

  return (
    <div style={{ width: "240px", display: "flex", flexDirection: "column", gap: "10px", padding: '10px', border: '1px solid #ccc', backgroundColor: "white", borderRadius: '8px', height: "fit-content" }}>
      
      <div style={{ display: "flex", flexDirection: "row", gap: "10px",   borderRadius: '8px', }}>
        <SaturationSpectrum value={selectedColor} onDrag={handleColorChange}   width={180} height={200} />
        <HueSpectrum value={selectedColor} onDrag={handleColorChange}   width={20} height={200}/>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "5px"
            }}
            >
            <div style={{ 
              backgroundColor: selectedColor, 
              padding: '5px 10px', 
              color: 'white', 
              fontSize: "12px",
              borderRadius: '4px', 
              height: "35px",
              width: "35px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              }}
              > 
              </div>
              <input
              type="text"
              placeholder="#Hex"
              value={customHex}
              onChange={handleHexChange}
              onKeyDown={handleHexKeyDown}
              style={{
                padding: '8px',
                fontSize: '12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                height: "35px",
                width: '80px',
                textAlign: 'center', 
                marginRight: '10px'
              }}
            />            
          </div>

        <button 
          onClick={handleSelectCallback} 
          style={{  
            padding: '8px 16px', 
            cursor: "pointer",
            border: "none",
            backgroundColor: "#d1d1d1", 
            color: '#1f1f1f', 
            height: "35px",
            width: "80px",
            borderRadius: '5px' 
            }}
        >
          Select
        </button>        
      </div> 
    </div>
  );
};
export { PrayselyColorPicker };